import React from 'react';
import { Space, Drawer } from 'antd';
import { DrawerCloseIcon } from 'utils/icons';
import PropTypes from 'prop-types';
import './index.scss';

function EbzDrawer({ title, viewMoreModal, toggleModal, children }) {
  return (
    <Drawer
      title={
        <Space
          direction="horizontal"
          style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
        >
          {title}
          <DrawerCloseIcon
            style={{
              color: 'var(--color-primary)',
              cursor: 'pointer'
            }}
            onClick={toggleModal}
          />
        </Space>
      }
      placement="right"
      width={550}
      closable={false}
      open={viewMoreModal}
      onClose={toggleModal}
      rootClassName="partner-ebz-drawer"
    >
      {children}
    </Drawer>
  );
}

EbzDrawer.defaultProps = {
  title: ''
};

EbzDrawer.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  viewMoreModal: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default EbzDrawer;
